import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state } from './state';

export const overviewPanel = {
    actions,
    getters,
    mutations,
    state
};



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/index.js